// Excel Compression JavaScript Interop Functions

// Create a download link for the compressed file
window.createDownloadLink = function (dataUrl, fileName) {
    return dataUrl;
};

// Trigger the download from a data URL
window.downloadFromUrl = function (dataUrl, fileName) {
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

// Function to upload a file (placeholder for future implementation)
window.uploadCompressedFile = async function (serverUrl) {
    // This would be implemented when server-side functionality is ready
    console.log("File upload functionality would connect to: " + serverUrl);

    return false;
};

// Helper function to convert base64 to ArrayBuffer
function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}